/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css, cx } from "@panda/css";
import { Box, BoxProps } from "@panda/jsx";

const tableHeaderStyles = css({
	width: "100%",
	display: "grid",
	gridTemplateColumns: "subgrid",
	gridColumn: "1 / -1",
	minHeight: "eds.dimension.40",
});

/**
 * Expects one or more TableColumn children to make up the header row.
 */

export interface CosmosTableHeaderProps extends BoxProps {
	className?: string;
	children: React.ReactNode;
}

export const CosmosTableHeader = ({
	className = "",
	children,
	...props
}: CosmosTableHeaderProps): React.JSX.Element => {
	return (
		<Box {...props} className={cx("cosmos-table__header", tableHeaderStyles, className)}>
			{children}
		</Box>
	);
};

CosmosTableHeader.displayName = "CosmosTable.Header";
